import PropTypes from 'prop-types';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import MyContext from '../context/MyContext';
import texts from '../services/texts';
import Menu from './Menu';
import Background01 from '../img/Background01.svg';
import Background02 from '../img/Background02.svg';
import Background03 from '../img/Background03.svg';
import Background04 from '../img/Background04.svg';
import Background05 from '../img/Background05.svg';
import Background06 from '../img/Background06.svg';
import BurgerMenu from './BurgerMenu';

export default function About({ self }) {
  const { language } = useContext(MyContext);
  const navigate = useNavigate();

  const random = Math.floor(Math.random() * 5);

  const image = [
    Background01,
    Background02,
    Background03,
    Background04,
    Background05,
    Background06,
  ];

  return (
    <>
      {self && (
      <>
        <Menu />
        <BurgerMenu />
      </>
      )}
      <div className="about" style={{ backgroundImage: `url(${image[random]})` }}>
        <div className="about-texts">
          <div>
            <h1 className="bounce-in-top">
              {texts.hero[language].split('').map(
                (letter, index) => (
                  <span
                    className="hero"
                    key={Math.random()}
                    style={{ animationDelay: `${index * 70}ms` }}
                  >
                    {letter}
                  </span>
                ),
              )}
            </h1>
          </div>
          {self ? (
            <div>
              <p>{texts.about[language].sentenceOne}</p>
              <p>{texts.about[language].sentenceTwo}</p>
              <p>{texts.about[language].sentenceThree}</p>
            </div>
          ) : (
            <div>
              {texts.heroSentence[language].split('/').map((world) => (
                <h4 className="hero2">{world}</h4>
              ))}
            </div>
          )}
          <div>
            <button
              type="button"
              className="btn"
              onClick={() => navigate('/contact')}
            >
              <span>
                {texts.contactButon[language]}
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

About.propTypes = {
  self: PropTypes.bool.isRequired,
};
